export default __webpack_public_path__ + "static/media/home-creative-agency-img-01.cf1ef4f4.jpg";